import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import getPopularsLibrary from 'api/courses/populars_library'
import { paths } from 'routes/paths'
import { CourseSection } from '../CourseSection'
import { useEffect } from 'react'

interface Props {
  search: string
  setIsLoading: (isLoading: boolean) => void
  setHasCourses: (hasCourses: boolean) => void
}

export const Populars: React.FC<Props> = ({
  search,
  setHasCourses,
  setIsLoading,
}) => {
  const { t } = useTranslation()
  const { data: populars, isLoading } = useSWR(
    {
      key: 'populars_library',
      search,
    },
    async (arg) =>
      getPopularsLibrary({
        page: 1,
        perPage: 8,
        search: arg.search,
      })
  )

  useEffect(() => {
    if (populars?.total && populars?.total > 0) {
      setHasCourses(true)
    }
    setIsLoading(isLoading)
  }, [isLoading, populars, setIsLoading, setHasCourses])

  return (
    <div>
      <CourseSection
        title={t('availableCourses.dropdown.populars')}
        isLoading={isLoading}
        courses={populars?.courses}
        totalCourses={populars?.total || 0}
        href={paths.library.populars}
      />
    </div>
  )
}
